import React, { useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import schema from './jsonSchema';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useTableGenerator from '../../common/functions/useTableGenerator';
import ClassService from './ClassService';
import { useNavigate } from 'react-router-dom';
import DirectoryService from 'components/app/directory/DirectoryService';
const WODClassTable = () => {
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [tableGenerated, setTableGenerated] = useState();
  const [refreshList, setRefreshList] = useState(false);
  const navigate = useNavigate();
  const formatDate = (dateValue) => {
    let date;
    
    // Handle date as array [year, month, day]
    if (Array.isArray(dateValue)) {
      const [year, month, day] = dateValue;
      date = new Date(year, month - 1, day);
    } else {
      date = new Date(dateValue);
    }
    
    // Format as DD/MM/YYYY
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  };


  const deleteWODClass = identification => {
    ClassService.deleteClass(identification)
      .then(response => {
        console.log(response);
      })
      .catch(error => console.log(error));
  };

  const jsonSchema = schema;

  useEffect(() => {
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    ClassService.retrieveAllClassesByAccount()
      .then(data => {
        // Get today's date at midnight (start of day)
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // Get date one week from now
        const oneWeekFromNow = new Date(today);
        oneWeekFromNow.setDate(today.getDate() + 7);
        oneWeekFromNow.setHours(23, 59, 59, 999);

        // Filter classes by date range (today to one week from now)
        const filteredData = data.filter(classItem => {
          if (!classItem.date) return false;
          
          // Handle date as array [year, month, day]
          let classDate;
          if (Array.isArray(classItem.date)) {
            const [year, month, day] = classItem.date;
            classDate = new Date(year, month - 1, day); // month is 0-indexed in JS Date
          } else {
            classDate = new Date(classItem.date);
          }
          
          return classDate >= today && classDate <= oneWeekFromNow;
        });

        // Sort by date in ascending order
        const sortedData = filteredData.sort((a, b) => {
          let dateA, dateB;
          
          if (Array.isArray(a.date)) {
            const [yearA, monthA, dayA] = a.date;
            dateA = new Date(yearA, monthA - 1, dayA);
          } else {
            dateA = new Date(a.date);
          }
          
          if (Array.isArray(b.date)) {
            const [yearB, monthB, dayB] = b.date;
            dateB = new Date(yearB, monthB - 1, dayB);
          } else {
            dateB = new Date(b.date);
          }
          
          return dateA - dateB; // Ascending order
        });

        // Format dates as DD/MM/YYYY
        const formattedData = sortedData.map(item => ({
          ...item,
          date: formatDate(item.date)
        }));


        const actionButtons = [
          {
            icon: 'edit',
            onClick: identifier => {
              console.log('Edit WODClass with identifier:', identifier);
              navigate('/app/wod/admin/classes/' + identifier);
            },
            className: 'p-0',
            title: 'Details',
            variant: 'action'
          }
        ];
        if (DirectoryService.isLoggedByAdmin()) {
          actionButtons.push(          
          {
            icon: 'trash-alt',
            onClick: identifier => {
              deleteWODClass(identifier);
              setRefreshList(true);
            },
            className: 'p-0',
            title: 'Delete',
            variant: 'action'
          });
        }
        setNoDataToShow(formattedData.length === 0);
        setTableGenerated(useTableGenerator(formattedData, jsonSchema, actionButtons));
        setRefreshList(false);
      })
      .catch(error => setError(error.message));
  }, [refreshList]);

  const buttonsConf = [];
  if(DirectoryService.isLoggedByAdmin()){
  buttonsConf.push(
    {
      name: 'Add class',
      icon: 'plus',
      type: 'button',
      variant: 'info',
      onClick: () => {
        navigate('/app/wod/admin/classes/create-form');
      }
    },
  );
}
  const headerGenerated = useHeaderGenerator('Upcoming Classes', ' ', buttonsConf);

  return (
    <>
      {error}
      {headerGenerated}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any WODClass to show.
        </Alert>
      )}
      {tableGenerated}
    </>
  );
};

export default WODClassTable;